import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import './index.css';
import { App } from './App';
import { queryClient } from '@/lib/queryClient';
import { initTelemetry } from '@/lib/telemetry';
import { installPageRestoreGuard } from '@/lib/pageRestoreGuard';

initTelemetry();
// Once per document: pageshow is an event of the document, and a restore
// can land on any page, the sign-in screen and redirect routes included.
installPageRestoreGuard();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
